export default "__VITE_ASSET__CMJbOiV1__"